import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Validators, AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-input-general',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    TranslatePipe,
    NgxMaskDirective,
  ],
  templateUrl: './input-general.html',
  styleUrl: './input-general.css',
})
export class InputGeneral {
  public hidePassword = input<boolean>(true);
  public TextPrefix = input<boolean>(false);
  public matTextPrefixIcon = input<string>('');
  public formControlGeneral = input<FormControl | AbstractControl | null>(new FormControl());
  public label = input<string>('');
  public placeholder = input<string>('');
  public mask = input<string>('');
  public prefix = input<string>('');
  public type = input<string>('');
  public suffix = input<string>('');
  public thousandSeparator = input<string>('');
  public allowNegativeNumbers = input<boolean>(false);
  public maxlength = input<number>(0);
  public typeInput = input<string>('');
  public pattern = input<string>('');
  public labelTop = input<boolean>(true);

  isRequired(control: AbstractControl | null): boolean {
    return !!control?.hasValidator?.(Validators.required);
  }

  getInputGeneral(): FormControl {
    return this.formControlGeneral() as FormControl;
  }
}
